module.exports = __webpack_public_path__ + "static/media/trophyRoom.773e788a.jpg";